import { generateTestId } from "@client-shared";

export const setInvoiceDetailDrawerTestId = (identifier: string): string => generateTestId("InvoiceDetailDrawer", identifier);

export const setInvoiceDetailDrawerTabTestId = (tab: "summary" | "line-items" | "audit"): string =>
  setInvoiceDetailDrawerTestId(`tab-${tab}`);
